<template>
  <div style="position: relative; display: block">
    
    <orderdetails-tour v-if="$store.state.tour && !loading" />
    

    <!--\
      <transition name="menu-popover" v-if="!loading && order != null">
      <div v-if="pdfPreview" class="lightbox">
        <h2 class="closeX" @click="closeLightbox()">
          <a>&#215;</a>
        </h2>
        <embed
          width="90%"
          height="100%"
          title="If you are having issues viewing this PDF, your browser security settings are set to download PDFs instead of viewing in the browser. You can also try using Chrome instead of Edge."
          :src="'data:application/pdf;base64,' + this.pdfPreview"
          style="background: #fff"
        />
      </div>
    </transition>
    
    -->
  


    <transition name="menu-popover" v-if="!loading && order != null">
    <div v-if="pdfUrl" class="lightbox">
      <h2 class="closeX" @click="closeLightbox()">
        <a>&#215;</a>
      </h2>
      <iframe
        :src="pdfUrl"
        width="90%"
        height="100%"
        style="background: #fff; border: none;"
        title="PDF Preview"
      />
    </div>
  </transition>

    <transition name="menu-popover" v-if="!loading && order != null">
      <div v-if="this.bundleSheet.length" class="lightbox">
        <h2 class="closeX" @click="closeBundleSheet()">
          <a>&#215;</a>
          <iframe
            style="
              width: 90%;
              height: 100%;
              position: relative;
              display: block;
            "
            :src="this.bundleSheet"
            title="Bundle Sheet"
          ></iframe>
        </h2>
      </div>
    </transition>


        <transition name="menu-popover" v-if="!loading && order != null">
      <div v-if="this.planningBlob?.length" class="lightbox">
        <h2 class="closeX" @click="closeBundleSheet()">
          <a>&#215;</a>
          <iframe
            style="
              width: 90%;
              height: 100%;
              position: relative;
              display: block;
            "
            :src="this.bundleSheet"
            title="Bundle Sheet"
          ></iframe>
        </h2>
      </div>
    </transition>

    <section
      v-if="loading && notFound == false"
      class="py-5 pixelsbg bs-shadow mobile-top"
      style="min-height: 293px"
    >
      <div class="container">
        <h1 class="text-white mb0 lh1">Loading Order....</h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <!--
        <h2 class="text-white lh1"></h2>
        <p class="text-white lh1">Loading details</p>
        -->
      </div>
    </section>

    <section
      v-else-if="!loading && notFound == true && order === null"
      class="py-5 pixelsbg bs-shadow mobile-top"
    >
      <div class="container">
        <h1 class="text-white mb0 lh1">Order Not Found</h1>
        <h2 class="text-white lh1"></h2>
        <p class="text-white lh1">
          Sorry, but we couldn't find that order number.
        </p>
      </div>
    </section>

    <section v-else class="py-5 pixelsbg bs-shadow mobile-top">



      <div class="container">


        
        <h1
          v-if="order != null && order.orderDetail[0].orderNo"
          class="text-white mb0 lh1"
        >
          {{ order.orderDetail[0].orderNo }}
        </h1>
        <h2 class="text-white lh1"></h2>
        <p
          v-if="order != null && order.orderDetail[0].projName"
          class="text-white lh1 mb0"
          v-html="order.orderDetail[0].projName"
        ></p>

        <div v-if="order != null" class="tracker-wrap">
          <ul class="progtrckr" data-progtrckr-steps="4">
            <li
              :class="calcProcessing ? 'progtrckr-done' : 'progtrckr-todo'"
            ></li>
            <li :class="calcPreProd ? 'progtrckr-done' : 'progtrckr-todo'"></li>
            <li :class="calcInProd ? 'progtrckr-done' : 'progtrckr-todo'"></li>
            <li :class="calcShipped ? 'progtrckr-done' : 'progtrckr-todo'"></li>
          </ul>
        </div>
        <div
          id="orderdetails-step-1"
          v-if="order != null"
          class="tracker-title-wrap"
        >
          <ul class="trckr-title mb0" data-progtrckr-steps="4">
            <li
              :class="calcProcessing ? 'trckr-title-done' : 'trckr-title-todo'"
            >
              Processing
            </li>

            <li :class="calcPreProd ? 'trckr-title-done' : 'trckr-title-todo'">
              Pre-Production
            </li>

            <li :class="calcInProd ? 'trckr-title-done' : 'trckr-title-todo'">
              In Production
            </li>

            <li :class="calcShipped ? 'trckr-title-done' : 'trckr-title-todo'">
              Shipped
            </li>
          </ul>
        </div>
      </div>


    </section>

    <div v-if="loading" class="row">
      <div class="col-xs-12 col-sm-12 col-12 col-lg-12">
        <div class="flex-box-wrap">
          <div class="flex-internal">
            <atom-spinner
              :animation-duration="1000"
              :size="40"
              :color="'#575757'"
            />
            <p>Loading......</p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      :class="
        !loading && notFound == true && order === null ? 'message-bg' : ''
      "
    >
      <!-- problem is not in the container -->
      <div
        v-if="!loading && notFound == true && order === null" class="pt30 container-fluid"
      >
        <div class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter">
          <div>
            <h2 style="margin: 30px 20px; color: #429da8; font-weight: 400">
              It looks like there is no order to show...
            </h2>
            <img src="@/assets/img/noData.svg" style="width: 100%" />
          </div>
        </div>
      </div>

      <div
        v-else
        class="mt30 mb20 container"
        style="position: relative; display: block"
      >
        <!-- col -->
        <div class="row">
          <div class="col-lg-8">
            <div class="card-back mb30 rounded bs-shadow p-3">
              <div id="orderdetails-step-3">
                <div
                  class="question-header d-flex align-items-center mb5 rounded"
                >
                  <div class="d-flex number-showing">
                    <button
                      @click="backLink"
                      class="mb0 lh1 mlauto list-btn dib d-flex center"
                    >
                      <i class="material-icons">keyboard_arrow_left</i>
                      Back
                    </button>
                  </div>

                  <div class="pag-wrapper mlauto" @click="backLink">
                    <h2 v-if="order != null && order.orderDetail[0].amount">
                      {{ formatPrice(order.orderDetail[0].amount) }}
                    </h2>
                    <h2
                      v-if="order != null && order.orderDetail[0].amount == 0"
                    >
                      {{ formatPrice(order.orderDetail[0].amount) }}
                    </h2>
                  </div>
                </div>
                <hr />
                <div class="info-top">
                  <div class="top-row d-flex">
                    <div v-if="order">

                      

                      <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">group</span><span style="margin-left: 5px;"> Representatives</span>  
                      </h6>


                      <p class="text-muted mb5 lh1">
                        <small
                          class="fw300"
                          v-if="order != null && order.orderDetail[0].salesman"
                        >
                          {{ order.orderDetail[0].salesman }}
                        </small>
                        <small class="fw300" v-else
                          >No representative assigned</small
                        >
                      </p>
                      <div v-if="order.itReps">
                        <p
                          v-for="rep in order.itReps"
                          :key="rep.repId"
                          class="text-muted mb5 lh1"
                        >
                          <small class="up fw300">
                            {{ rep.lastname + ", " + rep.firstname }}
                          </small>
                        </p>
                      </div>
                    </div>
                    <div id="orderdetails-step-2" class="status ml">
                      <p v-if="order" class="badge badge-success">
                        {{ order.orderStatus[0].status }}
                      </p>
                    </div>
                  </div>

               

                  <h6 class="mt20" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">corporate_fare</span><span style="margin-left: 5px;"> Area Contractors</span>  
                    </h6>



                  <p class="text-muted mb5 lh1">
                    <small
                      v-if="order != null && order.orderDetail[0].acName"
                      class="text-muted fw300"
                    >
                      {{ order.orderDetail[0].acName }}
                    </small>
                    <small v-else class="text-muted fw300"
                      >No area contractor assigned</small
                    >
                  </p>
                  <div v-if="order != null && order.itac">
                    <p
                      v-for="ac in order.itac"
                      :key="ac.acid"
                      class="text-muted mb5 lh1"
                    >
                      <small class="up lh1 fw300">{{ ac.acName }}</small>
                    </p>
                  </div>
                </div>
              </div>
              <hr />


              <h6 class="mt-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Order Name</span>  
                    </h6>
              <p class="text-muted mb20">
                <small
                  v-if="order != null && order.orderDetail[0].projName"
                  class="up lh1 fw300"
                >
                  {{ order.orderDetail[0].projName }}
                </small>
                <small v-else class="up lh1 fw300"> Unavailable </small>
              </p>

         
              <h6 class="mt-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Order Number</span>  
                    </h6>
              <p class="text-muted mb20">
                <small
                  v-if="order != null && order.orderDetail[0].orderNo"
                  class="up lh1 fw300"
                >
                  {{ order.orderDetail[0].orderNo }}
                </small>
              </p>


              <h6 class="mt-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Customer PO Number</span>  
              </h6>
              <p class="text-muted mb20">
                <small
                  v-if="order != null && order.orderDetail[0].customerPoNo"
                  class="up lh1 fw300"
                >
                  {{ order.orderDetail[0].customerPoNo }}
                </small>
              </p>


              <h6 class="mt-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">calendar_month</span><span style="margin-left: 5px;"> Date Entered</span>  
                    </h6>
              <p class="text-muted mb20">
                <small
                  v-if="order != null && order.orderDetail[0].dateEntered"
                  class="up lh1 fw300"
                >
                  {{
                    $moment(order.orderDetail[0].dateEntered).format(
                      "MM-DD-YYYY"
                    )
                  }}
                </small>
              </p>

              <div
                v-if="order != null && order.shipmentLines.length"
                style="margin-bottom: 20px"
              >
                <hr />

                <h6 class="mt-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">local_shipping</span><span style="margin-left: 5px;"> Tracking</span> 
                      
                    </h6>
                    <h6><small style="font-weight: 300; font-size: 80% !important">Shipment skid and weight details are located below in the Bill of Lading (BOL)</small></h6>

<!--
                <h6 class="mt-0">
                  <i class="fas fa-shipping-fast"></i> Tracking<br />
                  <small style="font-weight: 300; font-size: 80% !important"
                    >Shipment skid and weight details are located below in the
                    Bill of Lading (BOL)</small
                  >
                </h6>
              -->

                <ul
                  v-for="(line, index) in order.shipmentLines"
                  v-bind:key="index"
                  style="margin-left: 0; padding-left: 0; margin-bottom: 0"
                >
                  <li
                    style="padding-top: 5px; list-style-type: none"
                    class="fw300"
                  >
                    <p class="ship-head" style="margin-bottom: 0">
                      <span class="ship-number">
                        {{ " " }}{{ line.shipViaCode + ": " }}
                        <span class="ship-date">
                          <span v-if="line.proNo">
                            <span
                              v-if="
                                [
                                  'FEDEX FREIGHT PRIORITY',
                                  'FEDEX Freight ECONOMY',
                                  'FEDEX Heavy 3 Day',
                                  'FEDEX Heavy 2 Day',
                                  'FEDEX Heavy Next Day',
                                  'FEDEX 2nd Day',
                                  'FEDEX Next Day',
                                  'FED EXP Saver',
                                  'FEDX SAVER',
                                  'FEDEX GROUND',
                                  'FedEx Supply Chain Logistics',
                                  'FED EX',
                                  'FEDEX',
                                  'FEDX',
                                  'FEDX GROUND',
                                  'FED EXP SAVER (0537-0292-9)',
                                  'FEDEX Next Day (0537-0292-9)',
                                  'FEDEX GROUND (0537-0292-9)',
                                ].includes(line.shipViaCode) &&
                                !line.shipViaCode.includes('WILL CALL')
                              "
                            >
                              <a
                                :href="
                                  'https://www.fedex.com/fedextrack/?tracknumbers=' +
                                  line.proNo
                                "
                                class="pdfLink"
                                target="_blank"
                                rel="noopener noreferrer"
                                >{{ line.proNo }}</a
                              >
                            </span>

                            <span
                              v-else-if="
                                [
                                  'UPS',
                                  'UPS Next Day',
                                  'UPS Freight',
                                  'UPS 2nd Day',
                                  'UPS 3rd Day',
                                  'UPS Ground',
                                ].includes(line.shipViaCode) &&
                                !line.shipViaCode.includes('WILL CALL')
                              "
                            >
                              <a
                                :href="
                                  'https://www.ups.com/track?loc=null&tracknum=' +
                                  line.proNo +
                                  '&requester=WT/trackdetails'
                                "
                                target="_blank"
                                rel="noopener noreferrer"
                                class="pdfLink"
                                >{{ line.proNo }}</a
                              >
                            </span>

                            <span
                              v-else
                            >
                              {{ line.shipmentId }}
                            </span>

                          </span>

                          <!--
                             <span v-else>
                            <span
                  
                            >
                              {{ line.shipmentId }}
                            </span>
                          </span>
                          -->
                       

                        </span>
                      </span>
                    </p>
                  </li>
                </ul>
              </div>

              <!--
             <h6 class="my-0">
              <i class="fas fa-table"></i> Date Promised
            </h6>
            <p class="text-muted mb20">
              <small v-if="order.orderDetail[0].dateEntered" class="up lh1">
                {{
                moment(order.orderDetail[0].dateEntered).format("MM-DD-YYYY")
                }}
              </small>
            </p>
            -->


<div id="orderdetails-step-5" class="tab-container">
  <!-- Tab Headers -->
  <div class="nav-tabs-custom">
    <button
      :class="{ active: activeTab === 'lines' }"
      @click="activeTab = 'lines'"
      class="tab-button"
    >
      Lines
    </button>
    
    <button
      :class="{ active: activeTab === 'bol' }"
      @click="activeTab = 'bol'"
      class="tab-button"
    >
      BOL
    </button>
    
    <button
      :class="{ active: activeTab === 'charges' }"
      @click="activeTab = 'charges'"
      class="tab-button"
    >
      Charges
    </button>
    
    <button
      :class="{ active: activeTab === 'comments' }"
      @click="activeTab = 'comments'"
      class="tab-button"
    >
      Comments
    </button>
  </div>

  <!-- Tab Content -->
  <div class="tab-content-area">

    <!-- Lines Tab -->
    <div v-show="activeTab === 'lines'" class="tab-pane">
      <div style="display: flex; justify-content: flex-end; margin-bottom: 15px;">
        <download-csv
          v-if="downloadLines && downloadLines.length"
          :data="downloadLines"
          :name="order?.orderDetail?.[0]?.orderNo + '-order-lines.csv'"
          class="list-btn dib"
        >
          <span class="material-icons" style="font-size:18px">download</span>
          <span style="margin-left: 5px;">Download CSV</span>
        </download-csv>
      </div>

      <table v-if="order?.orderDetail?.[0]?.orderLines" class="table table-striped table-bordered lines-table mb0">
        <thead>
          <tr>
            <th>Part #</th>
            <th>Description</th>
            <th style="width: 8%">Qty</th>
            <th style="width: 15%">
              <span v-if="calcDisplayPromised">Promised</span>
              <span v-else>Estimated</span>
            </th>
            <th style="width: 15%">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, index) in order.orderDetail[0].orderLines" :key="index">
            <td><small class="text-muted">{{ line.catalogNo }}</small></td>
            <td><small class="text-muted">{{ line.catalogDesc }}</small></td>
            <td><small class="text-muted">{{ line.buyQty }}</small></td>
            <td><small class="text-muted">{{ $moment(line.promisedDeliveryDate).format("MM-DD-YYYY") }}</small></td>
            <td><small class="text-muted">{{ formatPrice(line.total) }}</small></td>
          </tr>
        </tbody>
      </table>
      <h6 v-else class="my-0 text-muted">No Lines Available</h6>
    </div>

    <!-- BOL Tab -->
    <div v-show="activeTab === 'bol'" class="tab-pane">
      <div v-if="order?.shipmentLines?.length">
        <ul
          v-for="(line, index) in order.shipmentLines"
          :key="index"
          class="bol bgwhite bs-shadow"
          @click="makeActive(index)"
        >
          <li class="parent">
            <small class="ship-head">
              <span class="ship-number" style="display: flex; align-items: center;">
                <span class="material-icons" style="font-size:18px">pallet</span>
                <span style="margin-left: 5px;">Shipment #{{ line.shipmentId }}</span>
              </span>

              <span class="ship-date" v-if="line.shipDate" style="display: flex; align-items: center;">
                <span class="material-icons" style="font-size:18px">calendar_month</span>
                <span style="margin-left: 5px;">{{ $moment(line.shipDate).format("MM-DD-YYYY") }}</span>
              </span>
              <span class="ship-date" v-else>Not Specified</span>

              <i class="p-1 my-auto fas fa-arrow-circle-down" style="width: 1.5em; height: 1.5rem"></i>
            </small>
          </li>

          <transition name="smooth" mode="out-in">
            <div v-if="open === index" class="info">
              <small class="ship-head">
                <span class="ship-number" style="display: flex; align-items: center;">
                  <span class="material-icons" style="font-size:18px">local_shipping</span>
                  <span style="margin-left: 5px;">{{ line.shipViaCode }}</span>
                </span>
                <span class="ship-date">
                  <i class="fas fa-truck-loading truck-no"></i>
                  <span v-if="line.proNo">Trailer #{{ line.proNo }}</span>
                </span>
              </small>
              <ul class="child-list">
                <li v-for="(detail, i) in line.shipmentHandlingUnitDTOs" :key="i" class="child">
                  <small class="w100 dflex">
                    <span class="pallet">
                      <i class="fas fa-pallet"></i> {{ detail.palletType }}
                    </span>
                    <span class="weight">
                      <i class="fas fa-weight"></i> {{ +detail.netWeight }} lbs
                    </span>
                  </small>
                </li>
              </ul>
            </div>
          </transition>
        </ul>
      </div>
      <h6 v-else class="my-0 text-muted">No Bill of Lading Available</h6>
    </div>

    <!-- Charges Tab -->
    <div v-show="activeTab === 'charges'" class="tab-pane">
      <table v-if="order?.orderDetail?.[0]?.orderCharges?.length" class="table table-striped table-bordered lines-table mb0">
        <thead>
          <tr>
            <th>Type</th>
            <th>Description</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(charge, index) in order.orderDetail[0].orderCharges" :key="index">
            <td><small class="text-muted">{{ charge.chargeType }}</small></td>
            <td><small class="text-muted">{{ charge.chargeTypeDesc }}</small></td>
            <td><small class="text-muted">{{ charge.chargedQty }}</small></td>
            <td><small class="text-muted">{{ formatPrice(charge.totalCharge) }}</small></td>
            <td><small class="text-muted">{{ formatPrice(charge.totalCharge) }}</small></td>
          </tr>
        </tbody>
      </table>
      <h6 v-else class="my-0 text-muted">No Charges Available</h6>
    </div>

    <!-- Comments Tab -->
    <div v-show="activeTab === 'comments'" class="tab-pane">
      <div v-if="order?.comment?.length">
        <div v-for="(comment, index) in order.comment" :key="index" class="comments">
          <div>
            <p class="d-flex mb0">
              <small class="text-muted">
                <i class="fas fa-comment"></i> {{ comment.senderUser }}
              </small>
              <small class="ml text-muted" style="display: flex">
                <i class="material-icons mr2 fs20">schedule</i>
                {{ $moment(comment.dateSent).subtract(1, "minutes").fromNow() }}
              </small>
            </p>
            <h6 class="my-0" style="max-width: 80%">{{ comment.message }}</h6>
          </div>
        </div>
      </div>
      <h6 v-else class="my-0 text-muted">No Comments</h6>

      <hr />
      <div class="form-group">
        <label>Message</label>
        <textarea
          v-model="commentString"
          class="form-control"
          rows="3"
          placeholder="Type your message here..."
        ></textarea>
      </div>

      <div class="flex-bottom">
        <button v-if="!commentString?.trim()" disabled class="submit-btn">Submit</button>
        <button v-else @click.prevent="insertComment" class="submit-btn">Submit</button>
      </div>
    </div>

  </div>
</div>
          
            </div>
          </div>




          <div class="col-lg-4 mb30">
            <div class="card-back mb30 rounded bs-shadow p-3">
              <ul id="orderdetails-step-4" class="list-group">
                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">download</span><span style="margin-left: 5px;"> Operating Instructions</span> 
                    </h6>
                    <router-link
                      :to="{ name: 'FieldService' }"
                      class="pdfLink fw300"
                      style="text-decoration: none"
                      >Service and Installation</router-link
                    >
                    </div>
                  </li>

                
                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">download</span><span style="margin-left: 5px;"> ETO Install Instructions</span>  
                    </h6>

                    <small class="text-muted">
                      <p
                        v-if="order != null && order.etoDocument.length"
                        class="mb0 fw300"
                      >
                        <a
                          target="_blank"
                          :href="order.etoDocument[0].filePath"
                          rel="noopener noreferrer"
                          class="pdfLink planning-link"
                        >
                          {{ order.etoDocument[0].docNo }}</a
                        >
                      </p>
                      <p v-else class="mb0 text-muted fw300">NA</p>
                    </small>
                  </div>
                </li>

                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">download</span><span style="margin-left: 5px;"> Acknowledgment</span>
                    </h6>

                    <small class="text-muted fw300">
           
                      <p
                        v-if="order != null && order.ack"
                        @click="showPDF(order.ack.pdfblog)"
                        class="pdfLink"
                      >
                        {{ $moment(order.ack.pdfdate).format("MM-DD-YYYY") }}
                      </p>
                      <p v-else class="mb0">NA</p>
                    </small>
                  </div>
                  </li>

                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <h6 class="my-0 Third" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">download</span><span style="margin-left: 5px;"> Bundling Sheet</span>
                    </h6>
                    <small class="text-muted fw300">
                      <p v-if="order != null && order.bundlesheet[0].doesExist == true" class="mb0">
                      
                        <a
                          target="_blank"
                          :href="
                            'https://reportviewer.spacesaver.com/Viewer.aspx?orderid=' +
                            orderId
                          "
                          rel="noopener noreferrer"
                          class="pdfLink planning-link"
                        >
                          Report</a
                        >
                       
      
                      </p>
                      <p v-else class="mb0 text-muted">NA</p>
                    </small>
                  </div>
                </li>
                <!--

                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div class>
                    <h6 class="my-0">
                      <i class="fas fa-file-download"></i> CONFIGURA FILES
                    </h6>

                    <small class="text-muted fw300">
                      <p v-if="order != null && order.configura.length">
                        <a
                          target="_blank"
                          :href="order.configura[0].filePath"
                          rel="noopener noreferrer"
                          class="pdfLink planning-link"
                        >
                          {{ order.configura[0].fileName }}</a
                        >
                      </p>
                      <p v-else class="mb0 text-muted">NA</p>
                    </small>
                  </div>
                  </li>
                -->

                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div class>
                 
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">download</span><span style="margin-left: 5px;"> Invoice(s)</span>  
                    </h6>
                    <div
                      v-if="
                        order != null && order.invoices && order.invoices.length
                      "
                    >
                      <small
                        v-for="invoice in order.invoices"
                        :key="invoice.pdfid"
                        class="text-muted fw300"
                      >
                        <p @click="showPDF(invoice.pdfblog)" class="pdfLink">
                          {{
                            invoice.pdfid +
                            " - " +
                            $moment(invoice.pdfdate).format("MM-DD-YYYY")
                          }}
                        </p>
                      </small>
                    </div>
                    <div v-else>
                      <small>
                        <p class="mb0 text-muted fw300">NA</p>
                      </small>
                    </div>
                  </div>
                  </li>

                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">download</span><span style="margin-left: 5px;"> Planning Paperwork</span>  
                    </h6>

                    
                   
                    <small v-if="order != null && order.planning.length" class="text-muted fw300">
                      <p
                      v-for="(paper, index) in order.planning"
                            v-bind:key="index"
                        class="mb0"
                      >
                        <a
                          target="_blank"
                          :href="paper.filePath"
                          rel="noopener noreferrer"
                          class="pdfLink planning-link"
                        >
                          {{ paper.docNo }}</a
                        >
                      </p>
                      
                    </small>

                   

                     <small v-if="order != null && order.planningBlob?.length" class="text-muted fw300">
                      <p class="mb0"
                       v-for="(paper, index) in order.planningBlob"
                            v-bind:key="index"
                      >
                      
                        <a
                          target="_blank"
                          @click="showPDF(paper.pdfblog)"
                          rel="noopener noreferrer"
                          class="pdfLink planning-link"
                        >
                          {{ paper.pdfid }}</a
                        >
                       
      
                      </p>
                      
                    </small>
                
                
                
                 <small v-else-if="!order && !order.planningBlob?.length && !order.planning.length">
                        <p class="mb0 text-muted fw300">NA</p>
                      </small>
              
                     
                
                  
                  </div>

                  </li>

                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <!--
                    <h6 class="my-0"><i class="fas fa-file-alt"></i> RGAs</h6>
                    -->
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> RGAs</span>  
                    </h6>

                    <div v-if="order != null && order.rga.length">
                      <small
                        v-for="rga in order.rga"
                        :key="rga.rgaid"
                        class="text-muted fw300"
                      >
                        <div>
                          <router-link
                            :to="/rga-details/ + rga.rgaid"
                            class="pdfLink"
                            style="text-decoration: none"
                            >{{ rga.rgaid + " - " + rga.status }}</router-link
                          >
                        </div>
                      </small>
                    </div>
                    <p v-else class="mb0 text-muted">
                      <small class="fw300">No RGA Submitted</small>
                    </p>
                  </div>
                  </li>
                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> RFRs</span>  
                    </h6>

                    <div v-if="order != null && order.rfr.length">
                      <small
                        v-for="rfr in order.rfr"
                        :key="rfr.rfrid"
                        class="text-muted fw300"
                      >
                        <div>
                          <router-link
                            :to="/rfr-details/ + rfr.rfrid"
                            class="pdfLink"
                            style="text-decoration: none"
                            >{{ rfr.rfrid + " - " + rfr.status }}</router-link
                          >
                        </div>
                      </small>
                    </div>
                    <p v-else class="mb0 text-muted">
                      <small class="fw300">No RFR Submitted</small>
                    </p>
                  </div>
                  </li>
                <li
                  class="
                    list-group-item
                    d-flex
                    justify-content-between
                    lh-condensed
                  "
                >
                  <div>
                    <h6 class="my-0" style="display: flex; align-items: center;">
                      <span class="material-icons" style="font-size:18px">text_snippet</span><span style="margin-left: 5px;"> Expedited Orders</span>  
                    </h6>

                    <div v-if="order != null && order.eo.length">
                      <small
                        v-for="eo in order.eo"
                        :key="eo.eoid"
                        class="text-muted fw300"
                      >
                        <div>
                          <router-link
                            :to="/expedited-order-details/ + eo.id"
                            class="pdfLink"
                            style="text-decoration: none"
                            >{{ eo.id }}</router-link
                          >
                        </div>
                      </small>
                    </div>
                    <p v-else class="mb0 text-muted">
                      <small class="fw300">No Expedited Order Submitted</small>
                    </p>
                  </div>
                  </li>
              </ul>
            </div>

        
            <div
              id="orderdetails-step-6"
              class="card-back mb5 rounded bs-shadow p-3"
            >
              <ul style="margin-left: 0; padding-left: 0; margin-bottom: 0">
                <li class="button-list">
                  <div class="d-flex w100">
                    
                    <router-link
                      :to="{ name: 'RGAadd', params: { id: orderId } }"
                      class="mb0 lh1 mlauto list-btn dib d-flex center w100"
                    >
                      RGA
                      <i class="material-icons">add</i>
                    </router-link>
                
                  </div>
                </li>

                <li class="button-list">
                  <div class="d-flex w100">
                    
                    <router-link
                      :to="{ name: 'RFRadd', params: { id: orderId } }"
                      class="mb0 lh1 mlauto list-btn dib d-flex center w100"
                    >
                      RFR
                      <i class="material-icons">add</i>
                    </router-link>
                  
                  </div>
                </li>

                <li class="button-list">
                  <div class="d-flex w100">
                   
                    <router-link
                      :to="{
                        name: 'ExpeditedOrderAdd',
                        params: { id: orderId },
                      }"
                      class="mb0 lh1 mlauto list-btn dib d-flex center w100"
                    >
                      Expedited Order Request
                      <i class="material-icons">add</i>
                    </router-link>
                
                  </div>
                </li>
                </ul>
            </div>
             
     
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
import moment from 'moment';
import orderdetailsTour from "../components/Tours/orderdetailsTour.vue";
import { formatCurrency } from '../utils/utils';

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
  },
};

export default {
  name: "OrderDetails",
  components: {
    AtomSpinner,
    // Avatar,
    orderdetailsTour,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      orderId: this.$route.params.id,
      userID: this.$store.state.user.UserId,
      bundleSheet: "",
      planningBlob: "",
      activeTab: 'lines',
      order: null,
      mainOrder: null,
      loading: false,
      processing: false,
      preprod: false,
      inprod: false,
      shipped: false,
      notFound: false,
      open: "",
      pdfPreview: "",
      pdfUrl: "",
      commentString: "",
      commentString4Email: "",
      days: null,
      scrolled: false,
      view: "orders",
      downloadLines: null,
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "order-manage");
      //return axios.get(this.endPointCompute, auth).then((response) => {
      return axios
        .get(`${this.ordermanageapi}/order/${this.orderId}`, auth)
        .then((response) => {
          // console.log(response);
          if (response.status == 204) {
            // console.log("no content");
            this.loading = false;
            this.notFound = true;
          } else {
            this.order = response.data;
            this.loading = false;
            document
              .getElementById("mobileScrollTarget")
              .scrollIntoView({ behavior: "smooth" });
          }
          this.orderLinesCSV();
        });
    },
    formatPrice(amount) {
      return formatCurrency(amount);
    },
    makeActive(item) {
      //console.log(item);
      if (this.open === item) {
        this.open = "";
      } else {
        this.open = item;
      }
    },
    copyLink: function () {
      this.$toast.success("Successfully copied link to clipboard!");
    },
    /*
    showPDF(doc) {
      console.log(doc)
      this.pdfPreview = doc;
    },
    */
    showPDF(pdfString) {
      if (!pdfString) {
        console.warn("No PDF data provided");
        return;
      }

      try {
        // Clean up old URL
        if (this.pdfUrl) {
          URL.revokeObjectURL(this.pdfUrl);
        }

        // Decode base64 → binary
        const byteCharacters = atob(pdfString);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        this.pdfUrl = URL.createObjectURL(blob);

      } catch (err) {
        console.error("Error creating PDF blob:", err);
        alert("Failed to load PDF. The file may be corrupted or empty.");
      }
    },
    
    closeLightbox() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
        this.pdfUrl = "";
      }
    },
    /*
    closeLightbox() {
      this.pdfPreview = "";
    },
    */
    backLink: function () {
      this.$router.back();
    },
    openBundleSheet: function (link) {
      this.bundleSheet = link;
    },
    closeBundleSheet: function () {
      this.bundleSheet = "";
      this.planningBlob = "";
    },
    openPlanningBlob: function (link) {
      this.planningBlob = link;
    },
    orderLinesCSV: function(){
      let i = 0;



      console.log("ran")
      let data = this.order.orderDetail[0].orderLines;
      
      /*
      this.downloadLines =  this.downloadLines.filter(function(ele){ 
            return ele != ele.relNo; 
      });
      */
      while (data[i]) {
        delete data[i].relNo;
        delete data[i].lineItemNo;
        delete data[i].currencyRate;
        // data[i]["orderNo"] = data[i]["Order Number"];
        i++;
      }
      this.downloadLines = data.sort((a,b) => a.lineNo - b.lineNo)
      console.log(data)
      //.sort(function(data){return data.lineNo - data.lineNo})
    },
    insertComment() {
      let createCase;
      let daysElapsed;
      const thePostDate = new Date();
      console.log("the post date " + thePostDate);
      //server time now
      let nowDate = this.$moment(this.order.serverTime);
      //console.log("now date: " + nowDate);
      //let lastPostDate = order.comment.dateSent;

      //console.log("last post sent " + lastPostObject.dateSent);
      if (this.order.comment.length && !this.employee) {
        const lastPostObject = [...this.order.comment].pop();
        const lastPostDate = this.$moment(lastPostObject.dateSent);
        //const daysElapsed = moment.duration(lastPostDate.diff(nowDate)).asDays();
        let daysElapsed = nowDate.diff(lastPostDate, "days");
        this.days = nowDate.diff(lastPostDate, "days");
        //console.log("days elapsed: " + daysElapsed);
        //console.log("last post: " + lastPostDate);
      } else {
        let daysElapsed = 0;
        this.days = 0;
      }

      this.commentString4Email = this.commentString;

      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
        },
      };

      let theDATA = {
        parentId: this.orderId,
        commentType: "Order",
        senderUserID: this.userID,
        dateSent: thePostDate,
        message: this.commentString,
        subject: `Order Comment: ${this.orderId}`,
      };

      let sfData = {
        orderNum: this.orderId,
        name: this.getName,
        emailAddress: this.getEmail,
        comment: this.commentString4Email,
      };

      /*
      let customerNotifydata = {
        message: this.commentString4Email,
        sender: this.getName,
        linkID: `order-details/${this.orderId}`,
        notify: this.rga.rga[0].requestorEmail,
      };
      */

      return axios
        .post(`${this.ordermanageapi}/comments`, theDATA, axiosConfig)
        .then((response) => {
          console.log(response);
          // this.$toast.success("Successfully added comment!");
          this.$toast.success("Successfully added comment!", { hideProgressBar: false, icon: false });
          //this.order.comment.push(theDATA);
          this.order.comment = response.data;
          this.commentString = "";
        })
        .then((response) => {
          //console.log("Send the comment");

          if (this.order.comment.length && this.employee == false) {
            //if there is no comments and not an employee
            //console.log("create an original case");
            return axios
              .post(
                `${this.server}/api/v1/salesforce-case-email`,
                sfData,
                axiosConfig
              )
              .then((response) => {
                //console.log(response);
                this.commentString4Email = "";
                // this.$toast.success("Successfully created a new salesforce case!");
                this.$toast.success("Successfully created a new salesforce case!", { hideProgressBar: false, icon: false });
              })
              .catch((err) => {
                //console.log(err);
                // this.$toast.error("Sorry, there was an issue making a new salesforce case");
                this.$toast.error("Sorry, there was an issue making a new salesforce case", { hideProgressBar: false, icon: false });
              });
          } 
          /*
          else if (
            this.order.comment.length &&
            this.employee == false &&
            this.days > 3
          ) {
            // there are comments, it's not an employee commenting, and the last comment is older than 4 days
            //console.log("Make a new case, it's aged");
            return axios
              .post(
                `${this.server}/api/v1/salesforce-case-email`,
                sfData,
                axiosConfig
              )
              .then((response) => {
                //console.log(response);
                this.commentString4Email = "";
                this.$toast.success(
                  "Successfully created a new salesforce case!"
                );
              })
              .catch((err) => {
                //console.log(err);
                this.$toast.error(
                  "Sorry, there was an issue making a new salesforce case"
                );
              });
          } 
          */
        })
        .catch((err) => {
          //console.log(err);
          // this.$toast.error("Sorry, there was an issue posting your comment");
          this.$toast.error("Sorry, there was an issue posting your comment", { hideProgressBar: false, icon: false });
        })
    },
  },
  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    getUsername() {
      return this.$store.state.user;
    },
    getEmail() {
      return this.$store.state.user.Email;
    },
    getName() {
      return (
        this.$store.state.user.FirstName + " " + this.$store.state.user.LastName
      );
    },
    calcProcessing: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate == "In Engineering" ||
          orderstate == "In Planning" ||
          orderstate == "Planned" ||
          orderstate == "Released" ||
          orderstate == "Reserved" ||
          orderstate == "Picked" ||
          orderstate == "Partially Delivered" ||
          orderstate == "Delivered" ||
          orderstate == "Invoiced/Closed"
        ) {
          //console.log("true");
          // this.processing = true;
          return true;
        } else {
          // this.processing = false;
          //console.log("false");
          return false;
        }
      } else {
        return;
      }
    },
    calcPreProd: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate === "In Planning" ||
          orderstate == "Planned" ||
          orderstate == "Released" ||
          orderstate == "Reserved" ||
          orderstate == "Picked" ||
          orderstate == "Partially Delivered" ||
          orderstate == "Delivered" ||
          orderstate == "Invoiced/Closed"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return;
      }
    },
    calcInProd: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate == "Released" ||
          orderstate == "Reserved" ||
          orderstate == "Picked" ||
          orderstate == "Partially Delivered" ||
          orderstate == "Delivered" ||
          orderstate == "Invoiced/Closed"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return;
      }
    },
    calcShipped: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (orderstate === "Delivered" || orderstate === "Invoiced/Closed") {
          return true;
        } else {
          return false;
        }
      } else {
        return;
      }
    },
    calcDisplayPromised: function () {
      if (this.order != null && this.loading == false) {
        let orderstate = this.order.orderStatus[0].status;
        if (
          orderstate == "Released" ||
          orderstate == "Reserved" ||
          orderstate == "Picked" ||
          orderstate == "Partially Delivered" ||
          orderstate == "Delivered" ||
          orderstate == "Invoiced/Closed"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return;
      }
    },
    employee() {
      return this.$store.getters.isSpacesaverEmployee;
    },
  },
  created() {
    this.$store.commit("showNavigation");
  },
  mounted() {
    document
      .getElementById("mobileScrollTarget")
      .scrollIntoView({ behavior: "smooth" });
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all and (min-width: 992px) {
  .flex-box-wrap {
    height: 200px;
    padding: 150px 0 125px 0;
    margin: 0;
  }
}

@media all and (max-width: 991px) {
  .flex-box-wrap {
    height: 100px;
    padding: 75px 0 50px 0;
    margin: 0;
    justify-content: center;
    align-items: center;
  }
}

.card-back {
  background: #fff;
}
.article {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.question-bottom {
  align-items: flex-end;
}
.question-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.center {
  align-items: center;
  justify-content: center;
}
.tab-container {
  background: #f2f2f3;
  padding: 10px;
  border-radius: 4px;
}
.nav-tabs {
  border-bottom: none;
}
.nav-tabs .nav-link {
  border: none;
}
#nav-tabContent {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
.d-flex {
  display: flex;
}
.ml {
  margin-left: auto;
}
/*
.comments:nth-child(even) {
  background: #efefef;
  padding: 10px;
  margin-bottom: 1rem;
  border-radius: 4px;
}
*/
.comments {
  border-bottom: 1px solid #efefef;
  padding: 10px 0;
}
.comments p {
  margin-bottom: 10px;
}
.comments:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.comments:last-child p {
  margin-bottom: 0;
}
.tab-container a {
  color: #429da8;
}
.mt30 {
  margin-top: 30px;
}
.badge {
  display: inline-block;
  padding: 0.5em 0.8em;
}
.progtrckr {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.progtrckr li {
  display: inline-block;
  text-align: center;
  line-height: 3.5em;
}

.progtrckr[data-progtrckr-steps="2"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="3"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="4"] li {
  width: 25%;
}
.progtrckr[data-progtrckr-steps="5"] li {
  width: 25%;
}

.progtrckr li.progtrckr-done {
  color: #fff;
  border-bottom: 4px solid #fff;
}
.progtrckr li.progtrckr-todo {
  color: #252627;
  border-bottom: 4px solid #252627;
}
.progtrckr li.progtrckr-partial {
  color: #ffff;
  border-bottom: 4px solid rgba(255, 255, 255, 0.5);
}

.progtrckr li:after {
  content: "\00a0\00a0";
  margin-left: 28px;
  /* this is the text*/
}
.progtrckr li:before {
  position: relative;
  bottom: -2.5em;
  float: left;
  left: calc(50% - 20px);
  line-height: 1em;
}
.progtrckr li.progtrckr-done:before {
  content: "\2713";
  color: #252627;
  background-color: #fff;
  height: 40px;
  width: 40px;
  line-height: 40px;
  border: none;
  border-radius: 40px;
}
.progtrckr li.progtrckr-todo:before {
  /*
  content: "\039F";
  color: #fff;
  background-color: #fff;
  font-size: 2.2em;
  bottom: -1.2em;
  */
  content: "\2713";
  color: #252627;
  background-color: #252627;
  height: 2.2em;
  width: 2.2em;
  line-height: 2.2em;
  border: none;
  border-radius: 2.2em;
}
.progtrckr li.progtrckr-partial:before {
  /*
  content: "\039F";
  color: #fff;
  background-color: #fff;
  font-size: 2.2em;
  bottom: -1.2em;
  */
  content: "\2713";
  color: rgba(255, 255, 255, 0);
  background-color: #9bdada;
  height: 2.2em;
  width: 2.2em;
  line-height: 2.2em;
  border: none;
  border-radius: 2.2em;
}

/* trackker titles */
.tracker-title-wrap {
  margin-top: 15px;
}
.trckr-title {
  padding-left: 0;
}
.trckr-title li {
  display: inline-block;
  text-align: center;
  line-height: 3.5em;
  width: 25%;
  color: #fff;
}
.trckr-title-done {
  color: #fff !important;
}
.trckr-title-todo {
  color: #252627 !important;
}
.badge-success {
  color: #fff;
  background-color: #3e4651;
}
@media all and (max-width: 700px) {
  .trckr-title li {
    font-size: 12px;
  }
}
.up {
  text-transform: uppercase;
}
.lines-table td,
.lines-table th {
  padding: 5px;
}
.small,
small {
  font-size: 90% !important;
}

.table td .small,
small {
  font-size: 90% !important;
}
.bol {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  padding: 10px;
  list-style-type: none;
  /*border: 1px solid #dee2e6;*/
  background: #efefef;
  margin-bottom: 5px;
  transition: background 0.8s linear;
  border-radius: 4px;
  cursor: pointer;
}
.bol:hover {
  background: #e6e5e5;
}
.parent {
  display: flex;
  align-items: center;
}
.parent i {
  transition: color 0.8s linear;
}
.parent:hover i {
  color: #000;
}
.parent:hover {
  color: #000;
}
.parent:active i {
  color: #00b4b4;
}
.child-list {
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  /*transition: height 0.8s linear;*/
  max-height: 100%;
  padding: 5px;
  margin-top: 10px;
  border-radius: 4px;
}
.child-list li {
  position: relative;
  list-style-type: none;
  margin-left: 0;
  border-bottom: 1px solid #dedede;
  padding: 5px;
}
.child-list li:last-of-type {
  border-bottom: none;
}
.is-closed {
  max-height: 0;
}
.show {
  /*height: 100% !important;*/
  max-height: 100% !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.smooth-enter-active,
.smooth-leave-active {
  transition: opacity 0.5s;
  height: auto;
}
.smooth-enter,
.smooth-leave-to {
  opacity: 0;
}

.height-enter-active,
.height-leave-active {
  transition: height 0.5s;
  height: auto;
}
.height-enter,
.height-leave-to {
  height: 0;
}
.ship-head {
  display: flex;
  width: 100%;
}
.pallet {
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ship-number {
  width: calc(50% + 3px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media all and (max-width: 700px) {
  .pallet {
    width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ship-number {
    width: calc(60% + 3px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.fa-arrow-circle-down {
  margin-left: auto;
}

.w100 {
  width: 100%;
}
.dflex {
  display: flex;
}
.info {
  border-top: 1px solid #dedede;
  padding-top: 5px;
  margin-top: 5px;
}
.truck-no {
  margin-left: -5px;
}
.closeX {
  top: 0;
}
.pdfLink {
  color: #429da8;
  cursor: pointer;
  margin-bottom: 0;
}
.pdfLink:hover {
  color: #00b4b4;
}
.pdfLink:active {
  color: #00b4b4;
}
.lightbox {
  z-index: 10003 !important;
}
.button-list {
  margin-bottom: 5px;
  list-style-type: none;
}
.submit-btn {
  border: none !important;
  padding: 7px 12px;
}
button:disabled {
  background: rgba(0, 0, 0, 0.2) !important;
  border: none !important;
}
.planning-link:hover {
  text-decoration: none;
}
.planning-link:active {
  text-decoration: none;
}

@media all and (max-width: 991px) {
  #nav-tabContent {
    overflow: scroll;
  }
  #nav-lines {
    width: 800px;
  }
}
.table td small {
  word-break: break-word;
}
.fw300 {
  font-weight: 300;
}

.tab-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-top: 15px;
}

.nav-tabs-custom {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  border-bottom: 2px solid #e5e7eb;
}

.tab-button {
  padding: 14px 28px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
}

.tab-button.active {
  color: #00b4b4;
  border-bottom: 3px solid #00b4b4;
  background: white;
  border-radius: 6px 6px 0 0;
}

.tab-content-area {
  background: white;
  padding: 25px;
  border-radius: 6px;
  min-height: 320px;
}

.tab-pane {
  display: block;
}

.submit-btn {
  background: #00b4b4;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 500;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
